// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const CashappIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'cashapp'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M21.6583 4.89287C21.4461 4.30901 21.1085 3.77877 20.6694 3.33946C20.2303 2.90016 19.7003 2.56247 19.1167 2.35015C18.025 2 17.0333 2 15.0167 2H8.96667C6.96667 2 5.95833 2 4.88333 2.33347C4.29887 2.54668 3.76831 2.88565 3.32914 3.32645C2.88996 3.76725 2.55287 4.29913 2.34167 4.88453C2 5.96832 2 6.96874 2 8.96957V15.0304C2 17.0396 2 18.0317 2.33333 19.1155C2.54556 19.6993 2.88312 20.2296 3.32224 20.6689C3.76136 21.1082 4.29138 21.4459 4.875 21.6582C5.95833 22 6.95833 22 8.95833 22H15.025C17.0333 22 18.0333 22 19.1083 21.6665C19.6943 21.4544 20.2265 21.1158 20.6672 20.675C21.1079 20.2341 21.4462 19.7017 21.6583 19.1155C22 18.0317 22 17.0313 22 15.0304V8.98624C22 6.97707 22 5.97666 21.6583 4.89287ZM16.5167 8.75281L15.7417 9.52814C15.6661 9.59842 15.5672 9.63817 15.4641 9.63971C15.361 9.64125 15.2609 9.60447 15.1833 9.53647C14.4328 8.90235 13.4824 8.55393 12.5 8.55273C11.6917 8.55273 10.8833 8.81951 10.8833 9.56148C10.8833 10.3118 11.75 10.5619 12.75 10.9371C14.5 11.5206 15.95 12.2543 15.95 13.9717C15.95 15.8391 14.5 17.123 12.1333 17.2647L11.9167 18.2651C11.8975 18.357 11.8473 18.4396 11.7744 18.4988C11.7016 18.558 11.6105 18.5903 11.5167 18.5902H10.025L9.95 18.5819C9.84323 18.5579 9.75017 18.4929 9.69092 18.4009C9.63167 18.3089 9.61098 18.1972 9.63333 18.09L9.86667 17.0313C8.96851 16.806 8.14254 16.3556 7.46667 15.7224V15.714C7.42938 15.6769 7.39979 15.6327 7.3796 15.5841C7.35941 15.5354 7.34902 15.4833 7.34902 15.4306C7.34902 15.3779 7.35941 15.3258 7.3796 15.2771C7.39979 15.2285 7.42938 15.1843 7.46667 15.1471L8.3 14.3385C8.37567 14.2676 8.47548 14.2281 8.57917 14.2281C8.68286 14.2281 8.78266 14.2676 8.85833 14.3385C9.61667 15.0554 10.6333 15.4556 11.6833 15.4389C12.7667 15.4389 13.4917 14.9804 13.4917 14.2551C13.4917 13.5298 12.7583 13.3381 11.375 12.8212C9.90833 12.296 8.51667 11.554 8.51667 9.81992C8.51667 7.80242 10.1917 6.81867 12.175 6.72697L12.3833 5.70154C12.4027 5.61041 12.4533 5.5289 12.5263 5.47107C12.5993 5.41323 12.6902 5.3827 12.7833 5.38474H14.2667L14.35 5.39308C14.5667 5.4431 14.7083 5.65152 14.6583 5.86828L14.4333 7.01042C15.1833 7.26052 15.8917 7.65235 16.5 8.16924L16.5167 8.18591C16.675 8.35265 16.675 8.60275 16.5167 8.75281Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
CashappIcon.displayName = 'CashappIcon'
export { CashappIcon }
